import { TFunction } from "i18next";
import {
  TEventCompetition,
  TEventCompetitionStrokePlay,
  TFoursomeCompetition,
  TPairCompetition,
  TPlayerCompetition,
  TTeamCompetition,
} from "redux/reducers/models/league";

export const formatOptions = (t: TFunction<"translation", undefined>) => [
  {
    id: "stroke_play",
    title: t("Stroke Play"),
  },
];

export const competitionOptions = (t: TFunction<"translation", undefined>) => [
  {
    id: "player_vs_field" as TPlayerCompetition,
    title: t("Player vs Field"),
  },
  {
    id: "player_vs_flight" as TPlayerCompetition,
    title: t("Player vs Flight"),
  },
  {
    id: "pair_vs_field" as TPairCompetition,
    title: t("Pair vs Field"),
  },
  {
    id: "pair_vs_flight" as TPairCompetition,
    title: t("Pair vs Flight"),
  },
  {
    id: "team_vs_field" as TTeamCompetition,
    title: t("Team vs Field"),
  },
  {
    id: "team_vs_flight" as TTeamCompetition,
    title: t("Team vs Flight"),
  },
  {
    id: "foursome_vs_field" as TFoursomeCompetition,
    title: t("Foursome vs Field"),
  },
  {
    id: "foursome_vs_flight" as TFoursomeCompetition,
    title: t("Foursome vs Flight"),
  },
];

export const competitionOptionsStrokePlay = (t: TFunction<"translation", undefined>) => [
  {
    id: "player_vs_field" as TEventCompetitionStrokePlay,
    title: t("Player vs Field"),
  },
  {
    id: "players_vs_flight" as TEventCompetitionStrokePlay,
    title: t("Players vs Flight"),
  },
  {
    id: "pair_vs_field" as TEventCompetitionStrokePlay,
    title: t("Pair vs Field"),
  },
  {
    id: "pair_vs_flight" as TEventCompetitionStrokePlay,
    title: t("Pair vs Flight"),
  },

  {
    id: "foursome_vs_field" as TEventCompetitionStrokePlay,
    title: t("Foursome vs Field"),
  },
  {
    id: "foursome_vs_field" as TEventCompetitionStrokePlay,
    title: t("Foursome vs Flight"),
  },
];

export const holesOptions = (t: TFunction<"translation", undefined>) => [
  {
    id: 9,
    title: "9",
  },
  {
    id: 18,
    title: "18",
  },
];

export const handicapFormatOptions = (t: TFunction<"translation", undefined>) => [
  {
    id: "gross",
    title: t("Gross"),
  },
  {
    id: "net",
    title: t("Net"),
  },
];
